import React from 'react';
import { withStyles } from '@material-ui/core';
import { styles } from '../styles';
import { StyledComponentProps } from '@material-ui/core/styles';


interface IProps extends StyledComponentProps {
    htmlContent: string;
    imgBase64: string;
}

const getFullHtml = (source: string) => {
    const style = `
    <style>
        .editor_content p { margin:0px }
        .editor_content figure { margin:0px }
        .editor_content p span { font-size:16px }

    </style>
    <div class='editor_content'>
    `
    const close = `</div>`
    return style + source + close;
}

const Preview = (props: IProps) => {
    let html = props.htmlContent;
    if (props.imgBase64)
        html = '<img style="width:100%;" src=' + props.imgBase64 + '></img>' + html;
    html = getFullHtml(html);
    return (
        <div>
            <div className={props.classes.device}>
                <div className={props.classes.content} dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </div>
    )
}

export default withStyles(styles)(Preview);